import React, {Component} from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux';

import NoticeListHeader from '../../components/contents/notice/NoticeListHeader'
import NoticeList from '../../components/contents/notice/NoticeList'
import Pagination from '../../components/common/Pagination';
import { parseListParams } from '../../components/common/EntryListHelper';
import ListWriteTitle from "../../components/common/list/ListWriteTitle";

@connect(state => ({
    items: state.notice.item.items,
    totalCount: state.notice.item.totalCount,
    searchKeyword: state.notice.condition.searchKeyword,
}))
class NoticeApp extends Component {

    render() {

        const { totalCount, searchKeyword } = this.props;

        return (
				<div className="inner_article contents_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
					<ListWriteTitle type="notice" headLabel="공지" totalCount={totalCount} searchKeyword={searchKeyword}/>
					<Route path="/notices" exact={false} strict={false} component={NoticeListHeader}/>
					<NoticeList/>
					<Pagination totalCount={totalCount} parseListParams={parseListParams}/>
				</div>
        )
    }
}

export default NoticeApp;
